document.querySelectorAll<HTMLElement>('.block-content-slider--slider').forEach((slider) => {
	const wrapper = slider.querySelector<HTMLElement>('.content-slider');

	const slidesPerViewMobile = wrapper?.getAttribute('data-slides-per-view-mobile')
		? wrapper?.getAttribute('data-slides-per-view-mobile')
		: 1.2;
	const slidesPerViewDesktop = wrapper?.getAttribute('data-slides-per-view-desktop')
		? wrapper?.getAttribute('data-slides-per-view-desktop')
		: 2.3;
	const slidesPerGroupMobile = wrapper?.getAttribute('data-slides-per-group-mobile')
		? wrapper?.getAttribute('data-slides-per-group-mobile')
		: 1;
	const slidesPerGroupDesktop = wrapper?.getAttribute('data-slides-per-group-desktop')
		? wrapper?.getAttribute('data-slides-per-group-desktop')
		: 1;
	const spaceBetween = wrapper?.getAttribute('data-space-between')
		? wrapper?.getAttribute('data-space-between')
		: 40;
	const loop = wrapper?.getAttribute('data-loop');

	const mediaBlocks = slider.querySelectorAll<HTMLElement>('.media') as NodeListOf<HTMLElement>;

	const iframes: HTMLIFrameElement[] = [];
	mediaBlocks.forEach((mediaBlock) => {
		const blockIframes = mediaBlock.querySelectorAll<HTMLIFrameElement>('iframe');
		iframes.push(...Array.from(blockIframes));
	});

	if (wrapper) {
		new (window as Window).Swiper(wrapper, {
			slidesPerView: Number(slidesPerViewMobile),
			slidesPerGroup: Number(slidesPerGroupMobile),
			spaceBetween: 20,
			loop: !!loop,
			loopAdditionalSlides: !!loop ? 2 : 0,
			slideClass: 'acf-block',
			navigation: {
				nextEl: '.content-slider__next',
				prevEl: '.content-slider__prev',
			},
			pagination: {
				el: '.content-slider__dots',
				clickable: true,
			},
			breakpoints: {
				992: {
					slidesPerView: Number(slidesPerViewDesktop),
					slidesPerGroup: Number(slidesPerGroupDesktop),
					spaceBetween: Number(spaceBetween),
				},
			},
			on: {
				slideChange() {
					if (iframes && mediaBlocks) {
						iframes.forEach((iframe) => {
							if (iframe.src?.includes('vimeo')) {
								const player = new window.Vimeo.Player(iframe);
								player.pause();
								player.setCurrentTime(0);
							}
						});
						mediaBlocks.forEach((mediaBlock) => {
							mediaBlock.classList.remove('active');
						});
					}
				},
			},
		});
	}
});
